import { motion } from "framer-motion";
import { Building2, Target, Users } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function AboutSection() {
  // Component hidden as requested
  return null;
  
  /* Original content preserved for future reference
  const values = [
    {
      icon: Building2,
      title: "Innovation Driven",
      description: "Based at Nexus Leeds and backed by WYCA Innovative Entrepreneurs Programme"
    },
    {
      icon: Target,
      title: "Industry Expertise",
      description: "Combining software development, manufacturing, and sustainability expertise"
    },
    {
      icon: Users,
      title: "SME Focused",
      description: "Leveling the playing field for smaller manufacturers to compete and thrive"
    }
  ];

  return (
    <div className="py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <motion.h2
            className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold relative mb-6 pb-1 leading-tight"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <div className="absolute -inset-1 bg-gradient-to-r from-[#00DC82]/20 to-transparent blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <span className="text-[#000c2a]">Who</span> <span className="text-[#00DC82]">We Are</span>
          </motion.h2>
          <motion.div 
            className="max-w-[856px] mx-auto space-y-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          >
            <p className="text-sm sm:text-base md:text-lg text-[#4D5B7C] leading-relaxed">
              Born from firsthand experience with manufacturing SME challenges, Sentiri helps small and medium-sized manufacturers stay compliant while reducing costs. Based at Nexus Leeds and backed by WYCA, we combine expertise in software, manufacturing, and sustainability to make compliance simple and cost-effective.
            </p>
            <p className="text-sm sm:text-base md:text-lg text-[#4D5B7C] leading-relaxed">
              Our mission: equip smaller manufacturers with smart tools to compete and thrive in an increasingly regulated world.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-3">
          {values.map((value, index) => (
            <motion.div
              key={value.title}
              className="relative group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 transform hover:-translate-y-1 border-[1.5px] border-[#00DC82]/10 hover:border-[#00DC82]/20 p-6"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="absolute inset-0 opacity-[0.03] bg-gradient-to-br from-[#00DC82] to-[#00B4B4]" />
              
              <div className="relative">
                <div className="w-12 h-12 md:w-14 md:h-14 mb-4 rounded-lg bg-gradient-to-br from-[#00DC82] to-[#00B4B4] p-3 text-white shadow-lg group-hover:scale-110 transition-transform duration-500">
                  <value.icon className="w-full h-full" />
                </div>
                
                <h3 className="text-lg font-semibold text-[#000c2a] mb-2 group-hover:text-[#00DC82] transition-colors duration-300">
                  {value.title}
                </h3>
                <p className="text-sm text-[#4D5B7C] leading-relaxed">
                  {value.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div 
          className="text-center mt-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <Button 
            size="lg" 
            className="bg-[#00DC82] text-white hover:bg-[#00DC82]/90"
            asChild
          >
            <Link to="/survey">
              Join our waitlist
            </Link>
          </Button>
        </motion.div>
      </div>
    </div>
  );
  */
}